import { render, staticRenderFns } from "./DashboardDetailList.vue?vue&type=template&id=0c3cc6bc&"
import script from "./DashboardDetailList.vue?vue&type=script&lang=js&"
export * from "./DashboardDetailList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports